$("body").on("click", '.btn-upload', function (ev) {
    var url = $(this).data('url');
    $('#upload-modal').find("iframe").attr('src', url);
    $("#upload-modal").on("hidden.bs.modal", function () {
        location.reload();
    });
});
$("#enable-campione").on('click',function(ev){
    orderCampione(ev,true);
})
$("#disable-campione").on('click',function(ev){
    orderCampione(ev,false);
})
$(document).on('click',".posizioni-checkbox :not(.no-stampa) .prodottiprint-inputcheckboxbutton",function(){
    setTimeout(()=>{
        scrollTo(".prodotti-print-blocco .prodotti-print-fake-title");
    },800)

});
$(document).on('click',".lavorazioniGroup .prodottiprint-inputradiobutton",function(){
    $("html,body").animate({ scrollTop: $(window).scrollTop() + 60 }, 1);
    // scrollTo(".anchorDimensioni")
});
$(document).on('click',".anchorDimensioni .prodottiprint-inputradiobutton",function(){
    $("html,body").animate({ scrollTop: $(window).scrollTop() + 60 }, 1);
});

function validateFormInput(element) {
    var validity = element.checkValidity();
    if (!validity) {
        $(element).addClass("is-invalid");
        $(element).siblings(".invalid-feedback").text(element.validationMessage);
    } else {
        $(element).removeClass("is-invalid");
        $(element).siblings(".invalid-feedback").text();
    }
}
//selector jquery .form-check input or .form-check select

$(".form-label-group input, .form-check input").blur(function () {
    var self = this;
    var validity = self.checkValidity();
    if (!validity) {
        $(self).addClass("is-invalid");
        $(self).siblings(".invalid-feedback").text(self.validationMessage);
    } else {
        $(self).removeClass("is-invalid");
        $(self).siblings(".invalid-feedback").text();
    }
})

// megamenu
document.addEventListener("DOMContentLoaded", function () {
    /////// Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function (element) {
        element.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    })

});

// overlay chiaro megamenu
document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.navbar .dropdown').forEach(function (everydropdown) {

        everydropdown.addEventListener('shown.bs.dropdown', function () {
            el_overlay = document.createElement('span');
            el_overlay.className = 'screen-lighten';
            document.body.appendChild(el_overlay)
        });

        everydropdown.addEventListener('hide.bs.dropdown', function () {
            document.body.removeChild(document.querySelector('.screen-lighten'));
        });

    });

});

$(document).on('focus', '.select2.select2-container', function (e) {
    // only open on original attempt - close focus event should not fire open
    if (e.originalEvent && $(this).find(".select2-selection--single").length > 0) {
        $(this).siblings('select').select2('open');
    }
});

document.addEventListener("search-content-loaded", function (e) {
    $(document).on("shown.bs.modal", '#searchModal', function () {
        $('#search-input').focus();
    });

    $('#search-button').click(function (e) {
        $('#search-input').attr("disabled", "disabled");
        let query = $("#search-input").val();
        search(query, 1);
        $('#search-input').removeAttr("disabled");
    });

    $('#search-input').on('keydown', function (e) {
        if (e.which === 13) {
            $('#search-button').click();
        }
    });


    $('#search-results').on('click', '.page-link', function (e) {
        let element = $(e.target);
        if ($(e.target).is('i')) {
            element = $(e.target).parent();
        }

        $('#search-input').attr("disabled", "disabled");
        let query = $("#search-input").val();
        search(query, element.data('href').split('page=')[1]);
        $('#search-input').removeAttr("disabled");
    });

    function search(query, page) {
        $('#search-results').html("");
        $('#search-spinner').show();

        axios.post("/search", {
            query: query,
            page: page
        })
            .then(function (response) {
                $('#search-spinner').hide();
                $('#search-results').html(response.data);
            });
    }
});

if ($('.infinite-scroll').length > 0) {
    $('ul.pagination').hide();
    $('.infinite-scroll').jscroll({
        autoTrigger: true,
        loadingHtml: '<div class="text-center pt-2"><i class="fa-solid fa-spinner fa-spin-pulse fa-2x"></i></div>',
        padding: 0,
        nextSelector: '.pagination li.active + li a',
        contentSelector: 'div.infinite-scroll',
        callback: function () {
            $('ul.pagination').remove();
        }
    });
}

$.ajaxSetup({
    complete: function () {
        bindImageErrorToLocal();
    }
});

$(document).ready(function () {
    bindImageErrorToLocal();
})

function bindImageErrorToLocal() {
    $("img").on("error", function () {
        const imageLocalPath = $(this).data('image-local');
        $(this).unbind("error");
        if ($(this).hasClass("lazyloaded") || $(this).hasClass("lazyloading")) {
            //L'errore è scattato dopo che l'immagine è stata lazyloadata, quindi devo caricarla subito
            $(this).attr("src", imageLocalPath);
            $(this).attr("data-bgset", imageLocalPath);
            $(this).siblings().each(function () {
                $(this).attr("srcset", imageLocalPath);
            });
        } else {
            $(this).attr("data-src", imageLocalPath);
            $(this).attr("data-bgset", imageLocalPath);
            $(this).siblings().each(function () {
                $(this).attr("data-srcset", imageLocalPath);
            });
        }
    });
}
function orderCampione(ev,enableDIsable){
    ev.preventDefault();
    ev.stopPropagation();
    let message;
    if(enableDIsable)
    {
        message = 1;
        $("#enable-campione").hide()
        $("#disable-campione").show()
    }
    else{
        message = 0;
        $("#enable-campione").show()
        $("#disable-campione").hide()
    }
    const customEvent = new CustomEvent('ordinaCampioneEvents', {
        detail: {
            message: message
        }
    });
    window.dispatchEvent(customEvent);
}
function scrollTo(el){
    if(el && $(el).length ) {
        let headerHeight = 0;
        if($('.header-container').length)
            headerHeight = $('.header-container').height();

         $("html,body").animate({scrollTop: $(el).offset().top - headerHeight }, 1);
    }
}
